import './App.css';
import {Routes, Route} from "react-router-dom";
import AppLayout from "./layout/app_layout";
import {AppProvider} from "./context/AppDataContext";
import {AuthProvider} from "./context/AppAuthContext";
import Login from "./pages/login/login";
import LandingPage from "./pages/landing/landing";
import Signup from "./pages/signup/signup";
import ProtectedRoute from "./components/protected_route/protected_route";
import ListingUploadTemp from "./pages/listing_upload_temp/listing_upload_temp";
import Post from "./pages/post/post";
import PageNotFound from "./exceptions/page_not_found/page_not_found";
import ServerError from "./exceptions/server_error/server_error";
import Listing from "./pages/listing/listing";


function App() {
    return (
        <AppProvider>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login/>} errorElement={<ServerError/>}/>
                    <Route path="/signup" element={<Signup/>} errorElement={<ServerError/>}/>
                    <Route path="/*" element={
                        <AppLayout>
                            <Routes>
                                <Route path={"*"} element={<PageNotFound/>}/>
                                <Route index path="/" element={<LandingPage/>}/>
                                <Route path="/post" element={
                                    <ProtectedRoute>
                                        <Post/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/listing/:listingID" element={
                                    <ProtectedRoute>
                                        <Listing/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/listing_upload" element={
                                    <ProtectedRoute>
                                        <ListingUploadTemp/>
                                    </ProtectedRoute>
                                }/>
                            </Routes>
                        </AppLayout>
                    } errorElement={<ServerError/>}
                    />
                </Routes>
            </AuthProvider>
        </AppProvider>
    );
}

export default App;
